import type { GroupBase, StylesConfig } from 'react-select';

export const getSharedStyles = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(
    overrides?: StylesConfig<Option, IsMulti, Group>,
) => {
    const sharedStyles: StylesConfig<Option, IsMulti, Group> = {
        control: (baseStyles) => ({
            ...baseStyles,
            boxShadow: 'none',
            borderColor: '#ccc',
            borderRadius: '0.4rem',
            ':hover': {
                ...baseStyles[':hover'],
                borderColor: '#ccc',
            },
            minHeight: '2rem',
        }),
        dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            padding: '4px',
        }),
        clearIndicator: (baseStyles) => ({
            ...baseStyles,
            padding: '4px',
        }),
        noOptionsMessage: (baseStyles) => ({
            ...baseStyles,
            textAlign: 'left',
        }),
        ...overrides,
    };

    return sharedStyles;
};
